import { useLingui } from '@lingui/react/macro';
import Maximize from '~icons/lucide/maximize-2';
import Minimize from '~icons/lucide/minimize-2';

import { Icon } from '#features/ui';
import { IconButton } from '#features/ui/components/IconButton';
import { Tooltip } from '#features/ui/components/Tooltip';

export const RoomModeButton = ({
  mode,
  onClick,
}: {
  mode: 'expand' | 'collapse';
  onClick: () => void;
}) => {
  const { t } = useLingui();
  const label = mode === 'expand' ? t`post:session.room.expand` : t`post:session.room.collapse`;
  const Glyph = mode === 'expand' ? Maximize : Minimize;
  return (
    <Tooltip content={label}>
      <IconButton
        variant="ghost"
        bg="bg.muted"
        color="fg.emphasized"
        boxSize={{ base: '44px', md: '40px' }}
        minW={{ base: '44px', md: '40px' }}
        flexShrink={0}
        aria-label={label}
        data-expand-target={mode === 'expand' ? '' : undefined}
        onPointerDown={(event) => event.stopPropagation()}
        onClick={onClick}
        css={{ '@media (any-pointer: coarse)': { minWidth: '44px', minHeight: '44px' } }}
      >
        <Icon boxSize={4.5}>
          <Glyph />
        </Icon>
      </IconButton>
    </Tooltip>
  );
};
